export default __webpack_public_path__ + "static/media/lock-circle.dcbc6d08.svg";